import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function IntakeExpandableCard({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}) {
  return <AnimatePresence data-id="element-373">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/40 p-0 sm:p-4 backdrop-blur-sm" data-id="element-374">
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-2xl overflow-hidden shadow-2xl flex flex-col max-h-[90vh] sm:max-h-[85vh]" data-id="element-375">
            <div className="flex items-center justify-between p-5 border-b border-slate-100 bg-white sticky top-0 z-10" data-id="element-376">
              <h3 className="font-semibold text-slate-900 pr-4 text-lg" data-id="element-377">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors flex-shrink-0" aria-label="Close" data-id="element-378">
                <XIcon className="w-5 h-5" data-id="element-379" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto bg-slate-50/50 flex-1" data-id="element-380">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}